import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { isProduction } from 'common/constants/env'

import { SUBSCRIPTION_TABS } from '../../constants'

import styles from './PageBar.module.scss'

const PageBar = ({ currentTab, handleTabClick }) => {
    const { t } = useTranslation()

    return (
        <div className="page-bar">
            <div className="title">
                <h1>{t('Billing and payments')}</h1>
            </div>
            <div className="tab">
                <ul>
                    <li
                        className={classNames({ 'is-active': currentTab === SUBSCRIPTION_TABS.subscription })}
                        onClick={handleTabClick(SUBSCRIPTION_TABS.subscription)}
                    >
                        {t('Subscription')}
                    </li>
                    <li
                        className={classNames({ 'is-active': currentTab === SUBSCRIPTION_TABS.billingHistory })}
                        onClick={handleTabClick(SUBSCRIPTION_TABS.billingHistory)}
                    >
                        {t('Billing history')}
                    </li>
                </ul>
            </div>
            <div className={styles.rightSide}>
                <a
                    className={styles.link}
                    target="_blank"
                    href={
                        isProduction
                            ? 'https://billing.stripe.com/p/login/9AQ8zW4SJ4R4cgg4gg'
                            : 'https://billing.stripe.com/p/login/test_fZe7we8iP3Uu7iE3cc'
                    }
                >
                    {t('Manage billing')}
                </a>
            </div>
        </div>
    )
}

export default PageBar
